import { matrixAllows } from './matrixAllows';

export function veCostosCompra(permisos) {
  return matrixAllows(permisos, 'productos', 'costos.ver');
}

export function conservaImporteComprobante(permisos) {
  if (veCostosCompra(permisos)) return true;
  return matrixAllows(permisos, 'compras', 'pagar')
    || matrixAllows(permisos, 'proveedores', 'cuenta_corriente.ver')
    || matrixAllows(permisos, 'proveedores', 'facturas.crear');
}

export function compraTieneRevisionPendiente(compra) {
  const estado = compra && compra.revision_costo_estado;
  if (estado === 'pendiente' || estado === 'registrada' || estado === 'incidente') return true;
  const incidente = compra && compra.revision_costo_incidente;
  return !!(incidente && incidente.recuperada !== true && estado !== 'resuelta' && estado !== 'recuperada');
}
